import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "guideContainer"
};
const _hoisted_2 = {
  class: "topBox"
};
const _hoisted_3 = {
  key: 0,
  class: "changeLanguage"
};
const _hoisted_4 = {
  class: "otherbtn"
};
const _hoisted_5 = {
  class: "searchBox"
};
const _hoisted_6 = {
  class: "innerbox"
};
const _hoisted_7 = ["placeholder"];
const _hoisted_8 = {
  key: 0,
  class: "othersBtn"
};
const _hoisted_9 = {
  key: 1,
  class: "swiper swiper-container",
  ref: "swiperNav"
};
const _hoisted_10 = {
  class: "swiper-wrapper"
};
const _hoisted_11 = ["onClick"];
const _hoisted_12 = ["src"];
const _hoisted_13 = {
  class: "title-box"
};
const _hoisted_14 = {
  class: "exhibition-title"
};
const _hoisted_15 = ["src"];
const _hoisted_16 = {
  class: "title-box"
};
const _hoisted_17 = {
  class: "exhibition-title"
};
const _hoisted_18 = {
  class: "exhibition-menu"
};
const _hoisted_19 = ["onClick"];
const _hoisted_20 = {
  key: 0,
  class: "exhibition-box"
};
const _hoisted_21 = {
  key: 1,
  class: "nullBox"
};
const _hoisted_22 = {
  class: "nullTips"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_guideTheme = _resolveComponent("guideTheme");
  const _component_exhibitionItemv2 = _resolveComponent("exhibitionItemv2");
  const _component_qrCode3 = _resolveComponent("qrCode3");
  const _component_guideBottom = _resolveComponent("guideBottom");
  const _component_hysbwg = _resolveComponent("hysbwg");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`audioGuideItem ${_ctx.$route.query.fid == 152288 ? 'nxbwgDz' : ''}`)
  }, [_createVNode(_component_guideTheme), _withDirectives(_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [!$data.searchBoxFlag && $data.exhibitions.length && $data.exhibitions.find(item => {
    return item.en_name;
  }) ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", {
    class: _normalizeClass(`chinese ${$data.language ? 'l_active' : ''}`),
    onClick: _cache[0] || (_cache[0] = $event => $options.changeLanguage(1))
  }, "中", 2), _createElementVNode("div", {
    class: _normalizeClass(`english ${!$data.language ? 'l_active' : ''}`),
    onClick: _cache[1] || (_cache[1] = $event => $options.changeLanguage(0))
  }, "EN", 2)])) : _createCommentVNode("", true), _withDirectives(_createElementVNode("ul", _hoisted_4, [_createElementVNode("li", {
    onClick: _cache[2] || (_cache[2] = $event => $data.searchBoxFlag = true)
  }, [...(_cache[16] || (_cache[16] = [_createElementVNode("i", {
    class: "icon-search"
  }, null, -1)]))]), _ctx.$route.query.fid != 332988 ? (_openBlock(), _createElementBlock("li", {
    key: 0,
    onClick: _cache[3] || (_cache[3] = $event => $data.showQrcode = true)
  }, [...(_cache[17] || (_cache[17] = [_createElementVNode("i", {
    class: "icon-qr-code"
  }, null, -1)]))])) : _createCommentVNode("", true)], 512), [[_vShow, !$data.searchBoxFlag]]), _withDirectives(_createElementVNode("div", _hoisted_5, [_createElementVNode("i", {
    onClick: _cache[4] || (_cache[4] = $event => $data.searchBoxFlag = false),
    class: "icon-arrow-left1"
  }), _createElementVNode("div", _hoisted_6, [_createElementVNode("i", {
    onClick: _cache[5] || (_cache[5] = (...args) => $options.search && $options.search(...args)),
    class: "icon-search"
  }), _withDirectives(_createElementVNode("input", {
    placeholder: $data.language ? '名称' : 'search',
    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.inputValue = $event),
    style: _normalizeStyle(!$data.language ? 'letter-spacing: 0' : ''),
    onKeydown: _cache[7] || (_cache[7] = (...args) => $options.search && $options.search(...args))
  }, null, 44, _hoisted_7), [[_vModelText, $data.inputValue]])])], 512), [[_vShow, $data.searchBoxFlag]])]), _ctx.$route.query.fid == 152288 ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", {
    onClick: _cache[8] || (_cache[8] = $event => $data.showQrcode = true)
  }, _toDisplayString($data.language ? '扫码讲解' : 'Scan Code'), 1), _createElementVNode("div", {
    onClick: _cache[9] || (_cache[9] = (...args) => $options.toArticle && $options.toArticle(...args))
  }, _toDisplayString($data.language ? '地图导览' : 'Map Guide'), 1), _createElementVNode("div", {
    onClick: _cache[10] || (_cache[10] = (...args) => $options.toExplanation && $options.toExplanation(...args))
  }, _toDisplayString($data.language ? '展厅讲解' : 'Exhibition Hall'), 1)])) : _createCommentVNode("", true), $data.bannersList.length && $data.bannersList.length > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.bannersList, item => {
    return _openBlock(), _createElementBlock("div", {
      class: "swiper-image swiper-slide",
      onClick: $event => $options.toBannerExhibition(item)
    }, [_createElementVNode("img", {
      class: "no-save-img",
      draggable: "false",
      onContextmenu: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["prevent"])),
      onDragstart: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["prevent"])),
      src: item.bannerImage
    }, null, 40, _hoisted_12), _createElementVNode("div", _hoisted_13, [_createElementVNode("span", _hoisted_14, _toDisplayString($data.language ? item.bannerName : item.englishName), 1)])], 8, _hoisted_11);
  }), 256))]), _cache[18] || (_cache[18] = _createElementVNode("div", {
    class: "swiper-pagination"
  }, null, -1))], 512)) : _createCommentVNode("", true), $data.bannersList.length && $data.bannersList.length == 1 ? (_openBlock(), _createElementBlock("div", {
    key: 2,
    class: "singleImage",
    onClick: _cache[15] || (_cache[15] = $event => $options.toBannerExhibition($data.bannersList[0]))
  }, [_createElementVNode("img", {
    class: "no-save-img",
    draggable: "false",
    onContextmenu: _cache[13] || (_cache[13] = _withModifiers(() => {}, ["prevent"])),
    onDragstart: _cache[14] || (_cache[14] = _withModifiers(() => {}, ["prevent"])),
    src: $data.bannersList[0].bannerImage
  }, null, 40, _hoisted_15), _createElementVNode("div", _hoisted_16, [_createElementVNode("span", _hoisted_17, _toDisplayString($data.language ? $data.bannersList[0].bannerName : $data.bannersList[0].englishName), 1)])])) : _createCommentVNode("", true), _createElementVNode("div", {
    class: "exhibitionContainer",
    style: _normalizeStyle(!$data.bannersList.length ? 'margin-top: 20px; min-height: 21rem;' : '')
  }, [_createElementVNode("div", _hoisted_18, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.exhibtypeList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: _normalizeClass($data.isActive === index ? 'menu_active' : ''),
      style: _normalizeStyle($data.language ? '' : 'font-size: 0.34rem'),
      onClick: $event => $options.typeClick(item, index)
    }, _toDisplayString($data.language ? item.title : item.en), 15, _hoisted_19);
  }), 128))]), $data.exhibitions.length ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_createVNode(_component_exhibitionItemv2, {
    exhibitions: $data.exhibitions,
    formData: $data.formData,
    language: $data.language,
    special: _ctx.$route.query.fid == 152288 ? 'nxbwg' : '',
    childList: $data.childList
  }, null, 8, ["exhibitions", "formData", "language", "special", "childList"])])) : (_openBlock(), _createElementBlock("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, _toDisplayString($data.loading ? '加载中...' : $data.inputValue ? '暂无搜索内容' : '暂无内容'), 1)]))], 4)], 512), [[_vShow, !$data.showQrcode]]), $data.showQrcode ? (_openBlock(), _createBlock(_component_qrCode3, {
    key: 0,
    show: $data.showQrcode
  }, null, 8, ["show"])) : _createCommentVNode("", true), _ctx.$route.query.fid == 152288 ? (_openBlock(), _createBlock(_component_guideBottom, {
    key: 1,
    activeIndex: 1,
    language: !$data.language
  }, null, 8, ["language"])) : _createCommentVNode("", true), _createVNode(_component_hysbwg, {
    name: "exhibitionsv2",
    type: "audio"
  })], 2);
}